module.exports = __webpack_public_path__ + "static/media/contact-background-img.87d72106.jpg";